"use strict";

var _defineProperty = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var Icon_1 = tslib_1.__importDefault(require("../../Icon"));

var constants_1 = require("../../../constants");

var styles = tslib_1.__importStar(require("./FoldButton.style"));

function FoldButton(props) {
  var _props$text = props.text,
      text = _props$text === void 0 ? '더 보기' : _props$text,
      onClick = props.onClick,
      className = props.className,
      _props$isFold = props.isFold,
      isFold = _props$isFold === void 0 ? false : _props$isFold,
      _props$disableTapHigh = props.disableTapHighlight,
      disableTapHighlight = _props$disableTapHigh === void 0 ? false : _props$disableTapHigh;
  return jsx_runtime_1.jsxs("button", Object.assign({
    type: "button",
    className: classnames_1.default(className, _defineProperty({}, constants_1.TAP_HIGHLIGHT_TRANSPARENT, disableTapHighlight)),
    css: styles.more,
    onClick: onClick
  }, {
    children: [jsx_runtime_1.jsx("span", Object.assign({
      className: "text"
    }, {
      children: text
    }), void 0), jsx_runtime_1.jsx(Icon_1.default, {
      name: isFold ? 'ic_arrowdown_xs_blue_500' : 'ic_arrowup_xs_blue_500',
      alt: "arrow"
    }, void 0)]
  }), void 0);
}

exports.default = react_1.memo(FoldButton);